import React from 'react';
import { Navigate } from 'react-router-dom';
import { hasRole } from '../utils/auth';

const RoleGuard = ({ roles = [], children, redirect = '/mock-interview' }) => {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" replace />;
  const list = Array.isArray(roles) ? roles : [roles];
  if (list.length === 0) return children;
  if (!hasRole(list)) return <Navigate to={redirect} replace />;
  return children;
};

export default RoleGuard;
